<div
  class="w-max text-b2 text-G900 font-medium underline underline-offset-2 decoration-G900 decoration-[2px] cursor-pointer"
  (click)="toggleContent()"
>
  {{ visible ? 'See More' : 'Minimize' }}
</div>
